/*
  AYO Mix & Match (sections/ayo-mix-match.liquid).
  1 pick a bag, 2 pick shoes (the ones whose color goes with the bag come first), 3 pick the shoe size,
  then one button adds both. The bottom bar shows the deal price all the way down the page.
*/
(function () {
  if (customElements.get('ayo-mix-match')) return;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (t, o) => String(t || '').replace(/\[(\w+)\]/g, (m, k) => (k in o ? o[k] : m));
  const moneyFmt = (cents, format) => {
    const f = (n, dec, th, ds) => { const [i, d] = (n / 100).toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : ''); };
    return String(format || 'LE {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      return f(cents, 2, ',', '.');
    }).replace(/[.,]00(?=\D*$)/, '');
  };

  // Color words (English and Arabic) -> color family
  const FAMILY = [
    ['white', /\b(white|off[- ]?white|ivory|snow)\b|ابيض|أبيض|اوف وايت/],
    ['dark', /\b(black|noir|navy|grey|gray|charcoal|anthracite)\b|اسود|أسود|كحلي|رمادي|رصاصي/],
    ['pink', /\b(pink|rose|blush|fuchsia|red|burgundy|wine|lilac|purple|lavender|mauve|coral)\b|بينك|وردي|روز|احمر|أحمر|نبيتي|موف|بنفسجي/],
    ['warm', /\b(beige|cream|nude|camel|tan|brown|chocolate|coffee|caramel|khaki|gold|golden|sand|taupe|mocha)\b|بيج|كريمي|بني|جملي|كافيه|ذهبي|هافان/],
    ['cool', /\b(blue|sky|denim|silver|mint|green|olive|teal|turquoise)\b|ازرق|أزرق|لبني|فضي|اخضر|أخضر|زيتي|منت/],
  ];
  const family = (k) => { const x = FAMILY.find(([, re]) => re.test(k || '')); return x ? x[0] : ''; };
  const goes = (bag, shoe) => {
    if (!bag || !shoe) return false;
    if (bag === shoe || shoe === 'white') return true;
    if (shoe === 'dark') return bag === 'warm' || bag === 'white';
    if (bag === 'dark' || bag === 'white') return shoe !== 'cool' || bag === 'white';
    return false;
  };
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class AyoMixMatch extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-ayo-mm-data]');
      if (!raw) return;
      try { this.d = JSON.parse(raw.textContent); } catch (e) { return; }
      this.t = this.d.text;
      this.pct = parseInt(this.dataset.pct, 10) || 0;
      this.useMatch = this.dataset.match === 'true';
      this.d.bags.forEach((p) => { p.f = family(p.k); });
      this.d.shoes.forEach((p) => { p.f = family(p.k); });
      this.bag = null; this.shoe = null; this.size = null;
      this.bagCat = ''; this.shoeCat = '';
      this.M = (c) => moneyFmt(c, this.d.money);
      this.addEventListener('click', (e) => this.onClick(e));
      document.body.classList.add('has-ayo-mm-bar');
      this.combos = this.makeCombos();
      this.chips();
      this.render();
      this.hero();
    }

    disconnectedCallback() { document.body.classList.remove('has-ayo-mm-bar'); clearInterval(this.heroT); clearTimeout(this.toastT); }

    $(sel) { return this.querySelector(sel); }
    byId(list, id) { return list.find((p) => p.id === id) || null; }

    // Loved matches: the Match blocks, or (when there are none) the first bags with a shoe that goes with each.
    makeCombos() {
      const out = [];
      (this.d.combos || []).forEach(([b, s]) => { const x = this.byId(this.d.bags, b), y = this.byId(this.d.shoes, s); if (x && y) out.push([x, y]); });
      if (out.length || !this.d.shoes.length) return out.slice(0, 8);
      const used = new Set();
      this.d.bags.slice(0, 12).forEach((b) => {
        if (out.length >= 4) return;
        const s = this.d.shoes.find((x) => !used.has(x.id) && (!this.useMatch || goes(b.f, x.f))) || this.d.shoes.find((x) => !used.has(x.id));
        if (s) { used.add(s.id); out.push([b, s]); }
      });
      return out;
    }

    chips() {
      const row = (kind, list, extra) => {
        const el = this.$(`[data-ayo-mm-chips="${kind}"]`);
        if (!el) return;
        const types = [];
        list.forEach((p) => { if (p.ty && types.indexOf(p.ty) < 0) types.push(p.ty); });
        const all = [['', this.t.all]].concat(extra || [], types.length > 1 ? types.map((x) => [x, x]) : []);
        el.hidden = all.length < 2;
        el.innerHTML = all.map(([v, n]) => `<button type="button" class="ayo-mm__chip" data-ayo-mm-chip="${kind}" data-v="${esc(v)}" aria-pressed="false">${esc(n)}</button>`).join('');
      };
      row('bag', this.d.bags);
      row('shoe', this.d.shoes, this.useMatch ? [['__goes', this.t.goes]] : []);
    }

    img(p, cls) { return p && p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="500" height="500"${cls ? ` class="${cls}"` : ''}>` : ''; }

    card(kind, p, on, match) {
      return `<button type="button" class="ayo-mm__card${on ? ' is-on' : ''}" data-ayo-mm-pick="${kind}" data-id="${p.id}" aria-pressed="${on}">
        <span class="ayo-mm__pic">${this.img(p)}${match ? `<span class="ayo-mm__goes">${esc(this.t.badge)}</span>` : ''}<span class="ayo-mm__tick" aria-hidden="true">✓</span></span>
        <span class="ayo-mm__name">${esc(p.t)}</span>
        <span class="ayo-mm__price">${esc(this.M(p.n))}${p.c > p.n ? ` <s>${esc(this.M(p.c))}</s>` : ''}</span>
      </button>`;
    }

    matches(s) { return this.useMatch && this.bag && goes(this.bag.f, s.f); }

    render() {
      const bags = this.d.bags.filter((p) => !this.bagCat || p.ty === this.bagCat);
      const bg = this.$('[data-ayo-mm-grid="bag"]');
      if (bg) bg.innerHTML = bags.map((p) => this.card('bag', p, this.bag && this.bag.id === p.id, false)).join('');
      const bc = this.$('[data-ayo-mm-bagcount]'); if (bc) bc.textContent = bags.length ? String(bags.length) : '';
      let shoes = this.d.shoes.filter((p) => !this.shoeCat || (this.shoeCat === '__goes' ? this.matches(p) : p.ty === this.shoeCat));
      if (this.bag && this.useMatch) shoes = shoes.map((p, i) => [p, i]).sort((a, b) => (this.matches(b[0]) - this.matches(a[0])) || (a[1] - b[1])).map((x) => x[0]);
      const sg = this.$('[data-ayo-mm-grid="shoe"]');
      if (sg) sg.innerHTML = shoes.map((p) => this.card('shoe', p, this.shoe && this.shoe.id === p.id, this.matches(p))).join('');
      this.querySelectorAll('[data-ayo-mm-chip]').forEach((c) => {
        const cur = c.dataset.ayoMmChip === 'bag' ? this.bagCat : this.shoeCat;
        const on = c.dataset.v === cur; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.paint();
    }

    stageHtml(b, s) {
      return `${b ? `<span class="ayo-mm__s ayo-mm__s--bag">${this.img(b)}</span>` : ''}${s ? `<span class="ayo-mm__s ayo-mm__s--shoe">${this.img(s)}</span>` : ''}`;
    }

    paint() {
      const b = this.bag, s = this.shoe;
      const stage = this.$('[data-ayo-mm-stage]');
      if (stage) {
        const key = `${b ? b.id : 0}-${s ? s.id : 0}`;
        if (stage.dataset.key !== key) { stage.dataset.key = key; stage.innerHTML = b || s ? `<span class="ayo-mm__duo">${this.stageHtml(b, s)}</span>` : stage.innerHTML.indexOf('ayo-mm__stage-empty') > -1 ? stage.innerHTML : ''; stage.classList.toggle('is-full', !!(b || s)); }
      }
      // sizes of the chosen shoes
      const zr = this.$('[data-ayo-mm-sizes]');
      if (zr) {
        if (!s) zr.innerHTML = `<span class="ayo-mm__hint">${esc(this.t.barShoes)}</span>`;
        else if (!s.z.length) zr.innerHTML = '';
        else zr.innerHTML = s.z.map(([n, id]) => `<button type="button" class="ayo-mm__size${this.size && this.size[1] === id ? ' is-on' : ''}" data-ayo-mm-size="${id}" aria-pressed="${!!(this.size && this.size[1] === id)}">${esc(n)}</button>`).join('');
      }
      const needSize = s && s.z.length > 0;
      const both = b && s;
      const ready = both && (!needSize || this.size);
      const shoePrice = this.size ? this.size[2] : (s ? s.n : 0);
      const sum = (b ? b.n : 0) + (s ? shoePrice : 0);
      const deal = both ? Math.round((sum * (100 - this.pct)) / 100) : sum;
      const saved = sum - deal;
      // steps
      const st = [!!b, !!s, !!ready];
      this.querySelectorAll('[data-ayo-mm-num]').forEach((el) => {
        const i = parseInt(el.dataset.ayoMmNum, 10) - 1;
        el.classList.toggle('is-ok', st[i]);
        el.classList.toggle('is-on', !st[i] && st.slice(0, i).every(Boolean));
        el.querySelector('b').textContent = st[i] ? '✓' : String(i + 1);
      });
      // bar
      const map = { saved: this.M(saved), size: this.size ? this.size[0] : '', percent: this.pct };
      const th = (k, p) => { const el = this.$(`[data-ayo-mm-thumb="${k}"]`); if (el) el.innerHTML = this.img(p); };
      th('bag', b); th('shoe', s);
      const total = this.$('[data-ayo-mm-total]'); if (total) total.textContent = this.M(deal);
      const was = this.$('[data-ayo-mm-was]'); if (was) { was.textContent = both && saved > 0 ? this.M(sum) : ''; }
      const note = this.$('[data-ayo-mm-note]');
      if (note) {
        note.textContent = !b ? this.t.barStart : (!s ? this.t.barShoes : fill(ready ? (needSize ? this.t.barSave : this.t.barSave.replace(/^[^·]*·\s*/, '')) : this.t.barSize, map));
        note.classList.toggle('is-ok', !!both);
      }
      const main = this.$('[data-ayo-mm-main]');
      if (main) { main.textContent = ready ? this.t.btnAdd : (both ? this.t.btnSize : (b ? this.t.btnNext : this.t.btnStart)); main.classList.toggle('is-ready', !!ready); }
      this.ready = !!ready;
    }

    go(n) {
      const el = this.$(`[data-ayo-mm-step="${n}"]`);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' }), 180);
    }

    onClick(e) {
      const go = e.target.closest('[data-ayo-mm-go]'); if (go) { this.go(go.dataset.ayoMmGo); return; }
      const chip = e.target.closest('[data-ayo-mm-chip]');
      if (chip) { if (chip.dataset.ayoMmChip === 'bag') this.bagCat = chip.dataset.v; else this.shoeCat = chip.dataset.v; this.render(); return; }
      const pick = e.target.closest('[data-ayo-mm-pick]');
      if (pick) {
        const id = parseInt(pick.dataset.id, 10);
        if (pick.dataset.ayoMmPick === 'bag') { const had = this.bag; this.bag = this.byId(this.d.bags, id); this.render(); if (!this.shoe && !had) this.go(2); }
        else { const prev = this.shoe; this.shoe = this.byId(this.d.shoes, id); if (prev !== this.shoe) this.size = null; this.render(); if (!this.size && this.shoe.z.length) this.go(3); }
        return;
      }
      const z = e.target.closest('[data-ayo-mm-size]');
      if (z) { const id = parseInt(z.dataset.ayoMmSize, 10); this.size = this.size && this.size[1] === id ? null : this.shoe.z.find((x) => x[1] === id); this.paint(); return; }
      const combo = e.target.closest('[data-ayo-mm-combo]');
      if (combo) { const [b, s] = this.combos[parseInt(combo.dataset.ayoMmCombo, 10)]; this.set(b, s); this.go(3); return; }
      if (e.target.closest('[data-ayo-mm-dice]')) { this.shuffle(); return; }
      if (e.target.closest('[data-ayo-mm-main]')) { this.main(); }
    }

    set(b, s) {
      if (this.shoe !== s) this.size = null;
      this.bag = b; this.shoe = s; this.bagCat = ''; this.shoeCat = '';
      this.render();
    }

    shuffle() {
      const B = this.d.bags, S = this.d.shoes;
      if (!B.length || !S.length) return;
      const b = B[Math.floor(Math.random() * B.length)];
      const good = this.useMatch ? S.filter((x) => goes(b.f, x.f)) : [];
      const pool = good.length ? good : S;
      this.set(b, pool[Math.floor(Math.random() * pool.length)]);
      const d = this.$('[data-ayo-mm-dice]'); if (d) { d.classList.remove('is-spin'); void d.offsetWidth; d.classList.add('is-spin'); }
    }

    hero() {
      const box = this.$('[data-ayo-mm-hero]');
      const loved = this.$('[data-ayo-mm-loved]');
      const row = this.$('[data-ayo-mm-combos]');
      if (row && this.combos.length) {
        row.innerHTML = this.combos.map(([b, s], i) => {
          const sum = b.n + s.n; const deal = Math.round((sum * (100 - this.pct)) / 100);
          return `<button type="button" class="ayo-mm__combo" data-ayo-mm-combo="${i}"><span class="ayo-mm__duo">${this.stageHtml(b, s)}</span><span class="ayo-mm__name">${esc(b.t)} + ${esc(s.t)}</span><span class="ayo-mm__price">${esc(this.M(deal))}${deal < sum ? ` <s>${esc(this.M(sum))}</s>` : ''}</span></button>`;
        }).join('');
        loved.hidden = false;
      }
      if (!box || box.querySelector('img.ayo-mm__show-img') || !this.combos.length) { if (box && !box.children.length) box.hidden = true; return; }
      let i = 0;
      const show = () => { const [b, s] = this.combos[i % this.combos.length]; box.innerHTML = `<span class="ayo-mm__duo is-in">${this.stageHtml(b, s)}</span>`; i += 1; };
      show();
      if (this.combos.length > 1 && !reduce()) this.heroT = setInterval(show, 2800);
    }

    toast(text, bad) {
      const el = this.$('[data-ayo-mm-toast]'); if (!el) return;
      el.textContent = text; el.classList.toggle('is-bad', !!bad); el.hidden = false;
      el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
      clearTimeout(this.toastT); this.toastT = setTimeout(() => { el.hidden = true; }, 2600);
    }

    async main() {
      if (!this.ready) { this.go(!this.bag ? 1 : (!this.shoe ? 2 : 3)); return; }
      const btn = this.$('[data-ayo-mm-main]');
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      const tag = { _bundle: 'Mix & Match' };
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [{ id: this.bag.v, quantity: 1, properties: tag }, { id: this.size ? this.size[1] : this.shoe.v, quantity: 1, properties: tag }] };
      if (cart && typeof cart.getSectionsToRender === 'function') { body.sections = cart.getSectionsToRender().map((x) => x.id); body.sections_url = window.location.pathname; }
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`.replace('.js.js', '.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || '');
        if (cart && data.sections && typeof cart.getSectionsToRender === 'function') {
          cart.classList.remove('is-empty');
          const inner = cart.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          cart.getSectionsToRender().forEach((sec) => {
            const html = data.sections[sec.id]; if (!html) return;
            const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id); if (!el) return;
            const src = new DOMParser().parseFromString(html, 'text/html').querySelector(sec.selector || '.shopify-section');
            if (src) el.innerHTML = src.innerHTML;
          });
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-mix-match', cartData: data });
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        this.toast(this.t.toast);
        if (cart && typeof cart.open === 'function') setTimeout(() => cart.open(), 900);
      } catch (err) {
        this.toast(err.message || this.t.error, true);
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }
  customElements.define('ayo-mix-match', AyoMixMatch);
})();
